const normalizeMember = (item) => ({
    id: item.id,
    name: item.name,
    credentials: item.credentials || undefined,
    title: item.title,
    biography: item.biography,
    profileImageUrl: item.profileImageUrl ?? item.profile_image_url ?? '',
});
const normalizeCategory = (item) => ({
    id: item.id,
    name: item.name,
    members: (item.members || []).map(normalizeMember),
});
export const normalizeBioPageContent = (data) => ({
    introContent: data.introContent ?? data.intro_content ?? '',
    categories: (data.categories || []).map(normalizeCategory),
});
